import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraCombobox, SpecraOverlayFooter } from '@mono/ui-components/lieutenants';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deliveryLogTouchpointHref, growthLogTouchpointHref } from './logTouchpointLinks';
/** Pursuits and programs this person appears on, as log targets. */ export function logTouchpointTargets(cards) {
    const seen = new Set();
    const out = [];
    for (const card of cards){
        for (const ctx of [
            card.primary,
            ...card.contexts
        ]){
            if (ctx.kind !== 'PURSUIT' && ctx.kind !== 'PROGRAM') continue;
            const key = `${ctx.kind}:${ctx.id}`;
            if (seen.has(key)) continue;
            seen.add(key);
            out.push(ctx);
        }
    }
    return out;
}
/**
 * Step 1 picks where the touchpoint happened; step 2 hands off by navigation:
 * a pursuit opens GRW-16's Log touchpoint with this person preselected, a
 * program opens Delivery's touchpoint form. No write happens here.
 */ export function LogTouchpointDialog({ open, onOpenChange, contactId, targets }) {
    const navigate = useNavigate();
    const [value, setValue] = useState(undefined);
    const chosen = targets.find((t)=>`${t.kind}:${t.id}` === value);
    const go = ()=>{
        if (!chosen) return;
        onOpenChange(false);
        navigate(chosen.kind === 'PURSUIT' ? growthLogTouchpointHref(chosen.id, contactId) : deliveryLogTouchpointHref(chosen.id, contactId));
    };
    return /*#__PURE__*/ _jsxs(SpecraOverlayDialog, {
        open: open,
        onOpenChange: onOpenChange,
        size: "md",
        title: "Log touchpoint",
        description: "Pick the pursuit or program it was about. You'll finish it there.",
        children: [
            /*#__PURE__*/ _jsx(SpecraCombobox, {
                label: "Pursuit or program",
                placeholder: "Choose where",
                searchPlaceholder: "Search",
                emptyMessage: "No pursuits or programs you can see.",
                value: value,
                onValueChange: setValue,
                options: targets.map((t)=>({
                        value: `${t.kind}:${t.id}`,
                        label: t.name,
                        textValue: t.name,
                        description: t.kind === 'PURSUIT' ? 'Pursuit' : 'Program'
                    }))
            }),
            /*#__PURE__*/ _jsx(SpecraOverlayFooter, {
                confirmLabel: "Continue",
                confirmDisabled: !chosen,
                onConfirm: go,
                onCancel: ()=>onOpenChange(false)
            })
        ]
    });
}
